module.exports = __webpack_public_path__ + "img/ico_24.fed0ec85.jpg";